@if (title != null) {
<h3 class="popover-header">
  <ng-template #simpleTitle>{{ title }}</ng-template>
  <ng-template
    [ngTemplateOutlet]="isTemplate(title) ? title : simpleTitle"
  ></ng-template>
</h3>
}
<div
  class="popover-body"
  data-e2e="popover"
  (cdkObserveContent)="contentChanged$.next($event)"
>
  <ng-template #simpleContent>{{ content }}</ng-template>
  <ng-template
    [ngTemplateOutlet]="isTemplate(content) ? content : simpleContent"
  ></ng-template>
</div>
